import type { TConversation } from '@cascade/api-client/conversations';
import { getStartOfMonth, groupBy } from '@cascade/core/utils';
import type { TConversationGroup } from './ConversationList.types.ts';

const getMonthTime = (conversation: TConversation): number =>
  getStartOfMonth(conversation.date).getTime();

export const groupConversationsByMonth = (
  conversations: TConversation[],
): TConversationGroup[] => {
  const groups = groupBy(conversations, getMonthTime);

  return [...groups].map(([monthTime, monthConversations]) => ({
    month: new Date(monthTime),
    conversations: monthConversations,
  }));
};
